<template>
  <div style="margin-left: 1em;
    margin-top: 1em;
  ">
  <v-snackbar v-model="msg" top>
    {{ text }}
    <v-btn color="pink" text  @click="msg = false">
      Close
    </v-btn>
  </v-snackbar>
    <v-card>
      <v-card-title style="background-color: #2b3990">
        <span class="headline white--text">{{ this.trainingId ? 'Edit inservice training' : 'Add inservice training'  }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12" sm="3" v-if="isAdmin">
              <v-autocomplete
                  clearable
                  :items="users"
                  item-text="Name"
                  item-value="_id"
                  label="Trainer(s)"
                  multiple
                  v-model="newTrainer"
                  prepend-icon="person"
                  chips
                  persistent-hint
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3" v-if="!isAdmin">
              <v-autocomplete
                  :items="users"
                  item-text="Name"
                  item-value="_id"
                  label="Trainer(s)"
                  multiple
                  v-model="newTrainer"
                  prepend-icon="person"
              ></v-autocomplete>
            </v-col>
            <v-col cols="12" sm="3">
              <v-autocomplete
                v-model="newTrainingType"
                label="Training Type"
                :items="Trainings"
                item-Name="Name"
                :readonly="!isAdmin"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" sm="3">
              <v-text-field
                v-model="newTrainingSubject"
                label="Training Subject"
                :items="Subjects"
                item-Name="Name"
                :readonly="!isAdmin"
              ></v-text-field>
            </v-col>

            <v-col cols="12" sm="3">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                :return-value.sync="date"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="newDate"
                    label="Date of Training"
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="newDate"
                  no-title
                  scrollable
                  :readonly="!isAdmin"
                >
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    color="primary"
                    @click="menu = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="$refs.menu.save(date)"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-select
                :items="times"
                v-model="newTimeStarted"
                label="Time Training Started"
                prepend-icon="mdi-clock-time-four-outline">
              </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="6">
              <v-select
                :items="times"
                v-model="newTimeEnded"
                label="Time Training Ended"
                prepend-icon="mdi-clock-time-four-outline"
                @change="calcHours()"
              >
              </v-select>
            </v-col>

            <v-col cols="12" sm="12" md="6">
              <v-text-field
                v-model="newDuration"
                label="Duration"
                prepend-icon="schedule"
                :readonly="!isAdmin"
                suffix="hrs"
              >
              </v-text-field>
            </v-col>

            <v-col cols="12" sm="12">
              <v-textarea
                v-model="newOutline"
                label="Training Outline"
                outlined
                :readonly="!isAdmin"
                auto-grow
              ></v-textarea>
            </v-col>

             <v-col cols="12" sm="12">
              <v-textarea
                v-model="newDescription"
                label="Training Description"
                outlined
                :readonly="!isAdmin"
                auto-grow
              ></v-textarea>
            </v-col>

            <v-col cols="12" sm="12">
              <v-text-field
                v-model="newLink"
                label="Training Link"
                outlined
                :readonly="!isAdmin"
              ></v-text-field>
            </v-col>

            <v-col cols="12">
              <v-file-input
                v-model="newDocument"
                class="pa-2"
                label="Select documents to upload"
                show-size
                filled
                multiple
                prepend-icon="mdi-camera"
                accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                @change="fileSelected"
              >
                <template #selection="{ text, index }">
                  <v-chip small label close color="primary" @click:close="deleteChip(index)">{{ text }}</v-chip>
                </template>
              </v-file-input>
          </v-col>
          <v-col cols="12" sm="12"
            v-for="doc in newDocument"
            :key="doc.id"
          >
            <div v-if="doc.ext !='pdf' ">
              <v-img
                max-height="480"
                max-width="550"
                :src="doc.aws"
              ></v-img>
            </div>
            <div v-if="doc.ext =='pdf' ">
              <LoadPdf
                :pdfFile="doc.aws"
                :pdfName="doc.name"
              />
            </div>
          </v-col>

          <v-col cols="12" sm="6">
            <template v-if="isAdmin">
              <v-checkbox
                label="Sign for Attending Training"
                @click="addSignature()"
                v-model="newSigned"
              ></v-checkbox>
            </template>
            <template v-else>
              <v-text-field
                label="Attendee Signature Status"
                :value="newSigned ? 'Signed' : 'Unsigned'"
                readonly
                outlined
              ></v-text-field>
            </template>
            <v-expand-transition v-if="newSigned">
              <v-text-field label="Signature" v-model="newSignature" readonly></v-text-field>
            </v-expand-transition>
          </v-col>

            <v-col cols="12" sm="6">
              <template v-if="isAdmin">
                <v-checkbox
                  label="Trainer Signature"
                  @click="addTrainerSignature()"
                  v-model="newTrainerSigned"
                ></v-checkbox>
              </template>
              <template v-else>
                <v-text-field
                  label="Trainer Signature Status"
                  :value="newTrainerSigned ? 'Signed' : 'Unsigned'"
                  readonly
                  outlined
                ></v-text-field>
              </template>
              <v-expand-transition v-if="newTrainerSigned">
                <v-text-field label="Signature" v-model="newTrainerSignature" readonly></v-text-field>
              </v-expand-transition>
            </v-col>

          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="#259647" class="white--text" @click="addTraining()" v-if="newTraining && !isAuditorRole">Save</v-btn
        >
        <v-btn
            fab
            small
            @click="showPrintModal()"
            class="mr-8 mb-2 white--text"
            color="#2b6993"
            elevation="4"
            v-if="editTraining"
            >
            <v-icon>print</v-icon>
        </v-btn>
        <v-btn color="#259647" class="white--text" @click="updateTraining()" v-if="editTraining && !isAuditorRole">Update</v-btn
        >
        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import LoadPdf from '@/components/LoadPDF.vue';
import { TRAININGTIMES } from '@/constants/ScheduleTime'
import renameFileHelper from '@/mixins/renameFileHelper';
import PrintUtil from "../../../utils/print-util";

const url = require("@/client_config/config").url;

export default {
  mixins: [renameFileHelper],
  components: {
    LoadPdf,
  },
  data: function() {
    return {
      titleForm: "",
      trainingId: this.$route.params.id,
      menu: false,
      newDate: moment(new Date()).format("YYYY-MM-DD"),
      newTimeStarted: '',
      newTimeEnded: '',
      newDuration: '',
      readonly: false,
      newCategory: "",
      categories: [],
      isAdmin: false,
      users: [],
      newTrainer: [],
      newTrainingType: "",
      times: TRAININGTIMES(),
      Trainings: ["Corporate Training (All Employees)", "Manager Training (All Managers)",
      "Asst Manager Training", "House Training", "Staff Training", "Bi-Weekly Training", "Adjustment Training"],
      Subjects: ["January Staff AT: Abuse, Neglect and Exploitation (Full Course) Client MR: The right to be treated with dignity and respect, the right to be free from abuse, neglect, and exploitation.",
      "February Staff AT: Medical Supports, Identifying & Managing Medical Emergencies 1. Identifying 2. Managing Client MR: The right to live in the least restrictive environment possible and to move freely in my environment, the right to have reasonable access to telephones and a reasonable amount of privacy.",
      "March Staff AT: Medication Supports Client MR: The right to have a private place to have visitors, the right to have writing materials, envelopes, and postage, the right to send and receive unopened mail.",
      "April Staff AT: Infection Control & Standard Precautions 1. Safe Food Handling Client MR: The right to have and keep personal possessions, the right to manage my own money and have access to financial records.",
      "May Staff AT: Documentation & Billing Requirements 1. Residential Service Log 2. Ancillary and Case Management Client MR: The right to make decisions about personal goals, the right to go to school and/or work and get paid for the work I do.",
      "June Staff AT: Abuse, Neglect and Exploitation (Abbreviated) Client MR: The right to vote, the right to participate in religious training or attend church.",
      "July Staff AT: Incident Reporting 1. The How's 2. The When's 3. The Why's Client MR: The Right to Freedom of Speech, the Right to have Friends & Close Relationships",
      "August Staff AT: Personal Rights/Responsibilities, Dignity and Respect, and Due Process with the HRC 1. Dignity and Respect 2. Due Process 3. HRC/BIC Client MR: The right to have assistance from my guardian if I need it, the right to have representation and/or advocacy.",
      "September Staff AT: Disaster and Emergency Preparedness Client MR: The right to be fully informed orally and in writing of my rights and responsibilities, the right to informed consent before treatment begins.",
      "October Staff AT: HIPAA & Confidentiality Client MR: The right to prompt and appropriate treatment in a manner consistent with current standards of practice that includes prevention of illness or disability, the right to appeal decisions as they relate to my plan.",
      "November Staff AT: Ethics, Boundaries and Professional Behaviors Client MR: The right to look at my clinical record, the right to have personal information shared only with my permission.",
      "December Staff AT: Positive Behavior Approaches and Supports Client MR: The right to refuse or select to be photographed and/or participate in research, the right to be informed of reasons for voluntary or mandatory transfer, admission, discharge, or commitment.",
      "ANE Specific Training",
      "Client Specific Training",
      "Clinical Disorders Charting",
      "Code of Conduct",
      "Ethics",
      "Hippa Specific Training",
      "House Meetings",
      "Managing Aggressive De-escalation",
      "Medication administration procedures",
      "Monthly Rights and CE Staff Training",
      "Personality Behavior",
      "Other",
      ],
      trainings: [],
      employeeID: this.$route.params.employeeID,
      newTrainingSubject: "",
      date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      newOutline: '',
      newDescription: '',
      newLink: '',
      newDocument: [],
      newSigned: false,
      newTrainerSigned: false,
      newSignature: "",
      newTrainerSignature: "",
      staff: localStorage.getItem("Name"),
      msg: false,
      text: "",
      token: localStorage.getItem('token'),
      canSign: false,
      userId: localStorage.getItem('userID'),
    }

  },

  computed: {
    newTraining() {
      return !this.trainingId;
    },

    editTraining() {
      return this.$route.params.action === 'edit';
    },

    generateDownloadUrl() {
      return `${url}/inserviceTraining/print-pdf?id=${this.trainingId}`;
    },

    isAuditorRole() {
      return localStorage.getItem("userRole") === 'Auditor'
    },

  },

  created() {
    let trainingId = this.$route.params.id;

    if (trainingId) {
      axios.get(`${url}/inserviceTraining/${trainingId}`).then((response) => {
        const item = response.data.training;
        this.viewTraining(item);
      });
    }

    this.getUsers();
    this.getTrainings();

    const userRole = localStorage.getItem('userRole');


    this.canSign = [
      "Assistant Manager",
      "House Manager",
      "Program Manager",
      "Administration",
      "Compliance Manager",
      "Client Services Manager",
      "Human Resources",
      "Medical Manager"
    ].includes(userRole);


    if(this.canSign || this.userId === this.employeeID){
      this.isAdmin = true
    }

    if (this.trainingId) {
      this.viewTraining();
    }

  },


  async mounted() {
      window.addEventListener('keydown', async (event) => {
          PrintUtil.handleKeydown(event, this.generateDownloadUrl, this.trainingId, this.token, 'inserviceTraining');
      });
  },

  beforeDestroy() {
      window.removeEventListener('keydown', (event) => {
          PrintUtil.handleKeydown(event, this.generateDownloadUrl, this.trainingId, this.token,'inserviceTraining');
      });
  },

  methods: {
    getUsers: function() {
      axios.get(`${url}/users`).then(async res => {
          this.users = res.data.users;
      });
    },

    getTrainings: function() {
      if (this.isLoading == true) return;

      this.isLoading = true;
      axios.get(`${url}/inserviceTraining/staff/${this.employeeID}`).then(res => {
        this.trainings = res.data.trainings;

      }).finally(() => this.isLoading = false);
    },

    calcHours() {

      if(this.newDate == ""){
          this.msg = true;
          this.text= "Please select date"
      }

      var start = moment(this.newDate + " " + this.newTimeStarted, "YYYY/MM/DD HH:mma")
      var end = moment(this.newDate + " " + this.newTimeEnded, "YYYY/MM/DD HH:mma")
      var hours = end.diff(start, "minutes")
      var minutes = parseInt(hours)/60
      this.newDuration = minutes
    },

    async fileSelected(e) {
      this.uploadFile = await this.renameFileHelper(e, this.staff, "InserviceTraining", this.newDate);
    },

    deleteChip(index) {
      this.newDocument.splice(index, 1);
    },

    addSignature: function() {
      if(!this.newSigned) return  this.newSignature = ''

      this.newSignature = this.staff + " - " + new Date();
    },

    addTrainerSignature() {
      if(!this.newSigned) return  this.newSignature = ''

      this.newTrainerSignature = this.staff + " - " + new Date();
    },

    addTraining: function() {
      let req_body = {
        Trainer: this.newTrainer,
        TrainingType: this.newTrainingType,
        TrainingSubject: this.newTrainingSubject,
        Date: this.newDate,
        TimeStarted: this.newTimeStarted,
        TimeEnded: this.newTimeEnded,
        Duration: this.newDuration,
        Outline: this.newOutline,
        Description: this.newDescription,
        Link: this.newLink,
        EmployeeID: this.employeeID,
        Signed: this.newSigned,
        Signature: this.newSignature,
        TrainerSignature: this.newTrainerSignature,
      };
      axios.post(`${url}/inserviceTraining`, req_body ).then(res => {
        if (res.status === 400) {
            res.json().then(function(data) {
              this.text = data.msg;
              this.msg = true;
            });
        }
        if(this.uploadFile !== null && this.uploadFile !== undefined){
          this.trainingId = res.data._id
          this.saveFile();
          this.$router.go(-1);
        }

        this.msg =true;
        this.text ="The new training has been added successfully.";
        this.close();
      });
    },


    saveFile() {
      this.message = "";
      for (let i = 0; i < this.uploadFile.length; i++) {
        this.uploadFiles(this.uploadFile[i]);
      }
    },

    uploadFiles(file) {
      const formData = new FormData();
      formData.append('inserviceTraining', file);
      var ct = { headers:{"content-type" : "multipart/form-data"}};
      axios.post(`${url}/inserviceTraining/fileuploader/${this.trainingId}/${this.employeeID}`,formData, ct)
      .then(res => {
        if(res){
          this.newDocument.push(res.data);
        }
      })
      .catch(err => {
        console.log(err);
      });
    },

    close() {
      this.$router.go(-1);
    },

    viewTraining() {
      axios.get(`${url}/inserviceTraining/${this.trainingId}` ).then(res => {
        const item = res.data.training;

        console.log({item});

        if (item.Signature == null){
          this.newSigned = false
        } else {
          this.newSigned = true
        }
        this.newTrainingType= item.TrainingType;
        this.newTrainingSubject= item.TrainingSubject;
        this.newDate= item.Date;
        this.newTimeStarted = this.formatToSelectTime(item.TimeStarted);
        this.newTimeEnded = this.formatToSelectTime(item.TimeEnded);

        // this.newTimeStarted= item.TimeStarted;
        // this.newTimeEnded= item.TimeEnded;
        this.newDuration= item.Duration;
        this.newOutline= item.Outline;
        this.newDescription = item.Description;
        this.newSigned = item.Signed;
        this.newTrainerSigned = !!item.TrainerSignature;
        this.newSignature = item.Signature;
        this.newTrainerSignature = item.TrainerSignature;
        this.newTrainer = item.Trainer;
        this.newLink = item.Link;
        this.trainingId= item._id;

        if(item.documents?.length > 0){
        const tempData = [];
        for(let i = 0; i < item.documents.length ; i++){
          let fileExt = item.documents[i].AWSLink.split('.').pop();
            tempData.push({
              name: item.documents[i].Name,
              id:  item.documents[i]._id,
              aws: item.documents[i].AWSLink,
              ext: fileExt

            });
          }
          this.newDocument = tempData;
        }
      });
    },

    async updateTraining() {
      let req_body = {
        TrainingType: this.newTrainingType,
        TrainingSubject: this.newTrainingSubject,
        Date: this.newDate,
        TimeStarted: this.newTimeStarted,
        TimeEnded: this.newTimeEnded,
        Duration: this.newDuration,
        Outline: this.newOutline,
        Description: this.newDescription,
        Signed: this.newSigned,
        Signature: this.newSignature,
        TrainerSignature: this.newTrainerSignature,
        Trainer: this.newTrainer.map((trainer) => {
          if (typeof trainer == "object") return trainer._id;
          return trainer;
        }),
        Link: this.newLink,
      };

      try {
        const response = await axios.put(`${url}/inserviceTraining/${this.trainingId}`, req_body);
        
        if (response.data && response.data.error) {
          this.msg = true;
          this.text = response.data.message || "Failed to update training.";
          return;
        }
        
        this.msg = true;
        this.text = "The training has been updated successfully.";
        
        if (this.uploadFile !== null && this.uploadFile !== undefined) {
          await this.saveFile();
        }
        
        this.close();
        
      } catch (error) {
        this.msg = true;
        
        if (error.response && error.response.data) {
          this.text = error.response.data.message || error.response.data.msg || "Failed to update training.";
        } else if (error.message) {
          this.text = error.message;
        } else {
          this.text = "An error occurred while updating the training.";
        }
      }
    },


    async showPrintModal() {
        PrintUtil.showPrintOption(this.generateDownloadUrl, this.trainingId, this.token,'inserviceTraining');
    },

    formatToSelectTime(timeString) {
      let date;
      const timeRegex = /^(\d{1,2}):(\d{2})(AM|PM)$/;
      if (timeRegex.test(timeString)) {
        const [, hours, minutes, ampm] = timeString.match(timeRegex);
        let hr = parseInt(hours, 10);
        const min = parseInt(minutes, 10);
        if (ampm === 'PM' && hr < 12) hr += 12;
        if (ampm === 'AM' && hr === 12) hr = 0;
        date = new Date();
        date.setHours(hr, min, 0, 0);
      } else {
        date = new Date(timeString);
        if (isNaN(date.getTime())) {
          return "Invalid Time";
        }
      }
      let hours = date.getHours();
      const minutes = date.getMinutes();
      const ampm = hours >= 12 ? 'PM' : 'AM';
      if (hours === 0) {
        hours = 12;
      } else if (hours > 12) {
        hours = hours % 12;
      }
      return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}${ampm}`;
    },

  },
}
</script>
